import IncomeStructureProvider from './IncomeStructureProvider';

export default IncomeStructureProvider;
